import React from 'react'
import PaymentContext from './payment-context'
import { createPaymentRequest, createPaymentResponse, createApplePayMerchantSession, deletePaymentProviderToken, fetchPaymentProviderTokens, fetchQfpayOverseaOauthUrl } from './payment-api'

export default function PaymentProvider({ children }) {
  const contextValue = {
    createPaymentRequest,
    createPaymentResponse,
    createApplePayMerchantSession,
    deletePaymentProviderToken,
    fetchPaymentProviderTokens,
    fetchQfpayOverseaOauthUrl
  }

  return (
    <PaymentContext.Provider value={contextValue}>
      {children}
    </PaymentContext.Provider>
  )
}
